import { render } from "./HelpEWBUpdate.vue?vue&type=template&id=0aeaff1a"
import script from "./HelpEWBUpdate.vue?vue&type=script&lang=js"
export * from "./HelpEWBUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__